import type { SuggestionSet } from "./SlashMenu";

export const gettingStartedSuggestions: SuggestionSet = {
  header: "Getting started",
  items: [
    {
      id: "brief",
      icon: "notebook-text",
      label: "Help me write a workflow brief",
      prompt:
        "Help me write a detailed brief for a new workflow. Ask me about what I want to automate, what tools I use, and what the expected outcome should be.",
    },
    {
      id: "questions",
      icon: "message-circle",
      label: "Ask me questions to understand my workflow",
      prompt:
        "I want to create a new workflow. Ask me questions to understand what I’m trying to accomplish, what steps are involved, and what tools or integrations I might need.",
    },
    {
      id: "suggest",
      icon: "sparkles",
      label: "Suggest workflows based on my connectors",
      prompt:
        "Based on the connectors I have connected, suggest some workflow ideas that could help automate my work. Focus on practical, time-saving automations.",
    },
  ],
};

export const workflowSuggestions: SuggestionSet = {
  header: "Suggestions",
  items: [
    {
      id: "summarize",
      icon: "notebook-text",
      label: "Summarize this workflow",
      prompt:
        "Explain what this workflow does step by step, including what triggers it, what each step does, and what the end result is.",
    },
    {
      id: "test",
      icon: "bug",
      label: "Test this workflow and identify issues",
      prompt:
        "Help me test this workflow with sample data and identify any potential issues or failure points.",
    },
    {
      id: "error-handling",
      icon: "shield-check",
      label: "Review for failure points and add error handling",
      prompt:
        "Review my workflow for potential failure points and suggest how to add proper error handling.",
    },
    {
      id: "edge-cases",
      icon: "refresh-ccw",
      label: "What edge cases might this not handle?",
      prompt:
        "Are there any edge cases or unusual scenarios that this workflow doesn’t handle? Help me identify and address them.",
    },
    {
      id: "schedule",
      icon: "calendar",
      label: "Add a schedule to run this automatically",
      prompt:
        "Help me set up a schedule or trigger so this workflow runs automatically at the right time or in response to an event.",
    },
    {
      id: "notify",
      icon: "bell",
      label: "Add notifications when this workflow runs",
      prompt:
        "Help me add notifications or alerts so I know when this workflow completes or if it fails.",
    },
    {
      id: "simplify",
      icon: "shrink",
      label: "Simplify this workflow",
      prompt:
        "Review this workflow and suggest ways to simplify it: remove unnecessary steps, combine redundant operations, and reduce complexity.",
    },
    {
      id: "optimize",
      icon: "rocket",
      label: "Suggest ways to improve this workflow",
      prompt:
        "Review my workflow and suggest ways to make it more efficient, reliable, or handle edge cases better.",
    },
    {
      id: "retry",
      icon: "redo-2",
      label: "Add retry logic for unreliable steps",
      prompt:
        "Review this workflow for steps that might fail intermittently (API calls, external services) and add retry logic to make them more resilient.",
    },
    {
      id: "logging",
      icon: "list-todo",
      label: "Add logging to track when this runs",
      prompt:
        "Help me add logging so I can track when this workflow runs and what it does each time.",
    },
    {
      id: "extend",
      icon: "link-2",
      label: "What else could I automate with this?",
      prompt:
        "Based on this workflow, what else could I automate that builds on it or connects to other connectors I use?",
    },
  ],
};
